import Vue from 'vue'

const TICK_INTERVAL = 1000

/**
 * A Vue plugin to add a centralised timer to synchronise ticks
 * - App.vue should #setup() and #teardown() the global instance
 * - Components can then #addListener() and #removeListener()
 */
export class TimerPlugin {
  constructor() {
    this.timerId = null
    this.listeners = []
  }

  static install(Vue) {
    Vue.prototype.$timer = new TimerPlugin()
  }

  setup() {
    if (this.timerId) return

    this.timerId = setInterval(() => this.tick(), TICK_INTERVAL)
  }
  teardown() {
    if (!this.timerId) return

    clearInterval(this.timerId)
  }
  tick() {
    for (const { handler } of this.listeners) handler()
  }

  addListener(owner, handler) {
    this.listeners.push({ handler, owner })
  }
  removeListener(owner) {
    this.listeners = this.listeners.filter(l => l.owner !== owner)
  }
}

Vue.use(TimerPlugin)
